import { motion } from "framer-motion";
import styled from "styled-components";

export const MainContainer = styled.div``;

export const ContainerWrapper = styled.div`
  position: relative;
  overflow: hidden; // 페이지 이동 시 요소가 영역을 벗어나지 않도록
`;

export const Container = styled(motion.main)`
  min-height: calc(100vh - 5.6rem);
  height: auto;
`;

export const MainWrap = styled.main`
  .main-bg {
    position: relative;
    width: 100%;

    .img-box {
      display: flex;
      img {
        max-width: 100%;
      }
    }
    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(34, 116, 101, 0.3);
    }
    .main-bg-txt {
      color: white;
      position: absolute;
      width: 100%;
      top: 23rem;
      p {
        max-width: 150.6rem;
        margin: 0 auto;
        white-space: pre-line;
        font-size: 3.6rem;
        font-weight: bold;
        line-height: 130%;
        br {
          display: none;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .main-bg {
      height: 80rem;
      min-height: auto;
      .img-box {
        height: 100%;
        img {
          object-fit: cover;
          object-position: 55%;
        }
      }
      .main-bg-txt {
        padding: 0 2rem;
        top: 24rem;
        p {
          font-size: 3.8rem;
          text-align: right;
          white-space: pre-line;
          br {
            display: block;
          }
        }
      }
    }
  }
`;

export const CSection = styled.section`
  margin-bottom: 8rem;
  .inner {
    max-width: 152.4rem;
    margin: 0 auto;
    .txt {
      padding: 5.8rem 0 8.3rem;
      p {
        text-align: center;
        color: #227465;
        font-weight: bold;
        font-size: 4rem;
        line-height: 1.2;
        font-family: "Pretendard";
        white-space: pre-line;
        br {
          display: none;
        }
      }
    }
    .advantage {
      display: grid;
      gap: 5rem 1rem;
      grid-template-columns: repeat(2, 1fr);
      max-width: 111.8rem;
      margin: 0 auto;
      .item-box {
        .img-box {
          width: 100%;
          height: 27.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            max-width: 100%;
          }
        }
        .txt-box {
          padding: 0 5rem;
          .title {
            margin-bottom: 1.2rem;
            p {
              color: #227465;
              font-family: "Pretendard";
              font-size: 2.8rem;
              font-weight: 900;
              line-height: 1.2;
            }
          }
          .paragraphs-box {
            p {
              color: #4b4b4b;
              font-size: 2rem;
              font-family: "Pretendard";
              font-weight: 400;
              line-height: 1.2;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .inner {
      .txt {
        padding: 7rem 2rem;
        p {
          font-size: 2.8rem;
          line-height: 1.4;
          br {
            display: block;
          }
        }
      }
      .advantage {
        grid-template-columns: repeat(1, 1fr);
        .item-box {
          .img-box {
          }
          .txt-box {
            padding: 0 3rem;
            .title {
              p {
              }
            }
            .paragraphs-box {
              p {
              }
            }
          }
        }
      }
    }
  }
`;

export const BSection = styled.section`
  margin-bottom: 9rem;
  .inner {
    max-width: 152.4rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background-color: #e6f4f2;
    padding: 5.6rem 4rem;
    gap: 5rem 4rem;
    border-radius: 2rem;
    .item-box {
      .top {
        display: flex;
        gap: 1rem;
        align-items: center;
        h3 {
          font-size: 2.4rem;
          font-family: "Pretendard";
          font-weight: bold;
          color: #0e3231;
        }
      }
      .list-box {
        margin-top: 2rem;
        margin-left: 4rem;
        li {
          color: #4b4b4b;
          font-size: 2rem;
          line-height: 1.4;
          font-family: "Pretendard";
          font-weight: 600;
        }
      }
    }
  }
  .bg-logo-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    margin-top: 10rem;
    margin-bottom: 13rem;
  }
  @media screen and (max-width: 768px) {
    .inner {
      margin: 0 2rem;
      padding: 3rem 2rem;
      grid-template-columns: repeat(1, 1fr);
      .item-box {
        .top {
        }
        .list-box {
          margin-top: 1rem;
          margin-left: 1rem;
          li {
            font-size: 1.8rem;
          }
        }
      }
    }
  }
`;

export const FooterContainer = styled.footer`
  height: 8.8rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0e3231;
  h3 {
    color: #838383;
    font-size: 1.5rem;
    font-family: "Pretendard";
    font-weight: 500;
    transform: translateY(3px);
  }
  .logo {
    position: absolute;
    left: 4rem;
  }
  @media screen and (max-width: 768px) {
    height: 18rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    h3 {
      font-size: 1.3rem;
    }
    .logo {
      position: static;
      display: flex;
      align-items: center;
      gap: 0.4rem;
      .icon-box {
        width: 4rem;
        img {
          max-width: 100%;
        }
      }
      .img-box {
        max-width: 15rem;
        img {
          max-width: 100%;
        }
      }
    }
  }
`;

export const JoinContainer = styled.div`
  min-height: calc(100vh - 8.3rem);
  background-color: #c1e4de;
  padding-top: 16rem;
  form {
    max-width: 40rem;
    margin: 0 auto;
    h3 {
      font-size: 2.8rem;
      text-align: center;
      margin-bottom: 3rem;
    }
    .form-box {
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
      .input-box {
        input {
          width: 100%;
          padding: 1.2rem 2.3rem;
          font-size: 1.4rem;
          border: none;
          border-radius: 0.4rem;
        }
      }
      .join-select {
        .react-select__value-container {
          padding: 0.7rem 2rem;
          font-size: 1.4rem;
          line-height: 1;
        }
      }
    }
    .submit-box {
      button {
        width: 100%;
        margin-top: 0.8rem;
        font-size: 1.8rem;
        padding: 1.2rem;
        border: none;
        outline: none;
        background-color: #2d2d2d;
        color: white;
        border-radius: 0.4rem;
      }
    }
  }
  .list-info-item {
    max-width: 58rem;
    margin: 6rem auto;
    ul {
      li {
        font-size: 1.8rem;
        color: #30a690;
        display: flex;
        align-items: center;
        gap: 1.5rem;
        line-height: 1.5;
        letter-spacing: -0.03rem;
        b {
          width: 0.8rem;
          height: 0.8rem;
          display: block;
          border-radius: 50%;
          background-color: #30a690;
        }
        br {
          display: none;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding-top: 5rem;
    form {
      max-width: none;
      width: 100%;
      padding: 2rem;
      h3 {
      }
      .form-box {
        .input-box {
          input {
          }
        }
        .join-select {
          .react-select__value-container {
          }
        }
      }
      .submit-box {
        button {
        }
      }
    }
    .list-info-item {
      max-width: none;
      width: 100%;
      padding: 2rem 2rem 6rem;
      margin: 3rem auto 6rem;
      ul {
        li {
          font-size: 1.4rem;
          margin-bottom: 0.6rem;
          b {
            width: 6px;
            height: 6px;
          }
          br {
            display: block;
          }
        }
      }
    }
  }
`;
